window.PopupController = {

    popup: null,

    opened: false,


    init(){

        this.popup = document.getElementById(
            "MaisaWelcomePopup"
        );

    },


    show(){

        if(!this.popup) return;

        this.popup.classList.add("active");

        this.popup.setAttribute(
            "aria-hidden",
            "false"
        );

        document.body.style.overflow = "hidden";

        PopupStorage.setLastShown();

        console.log("Popup mostrado");

    },


    hide(){

        if(!this.popup) return;

        this.popup.classList.remove("active");

        this.popup.setAttribute(
            "aria-hidden",
            "true"
        );

        document.body.style.overflow = "";

        console.log("Popup cerrado");

    },


    openOnce(){

        if(this.opened) return;

        this.opened = true;

        this.show();

    }

};